import React, { useRef } from "react";

import styled from "styled-components/macro";

import {
  useACHIsEditing,
  useRoutingNumber,
} from "Payments/AddPaymentMethod/paymentMethodStateHooks";

import {
  Info,
  Label,
  SmallNumber,
  SmallNumberInput,
  Stack,
} from "./styledComponents";

export default function AccountNumber() {
  const inputRef = useRef();

  const [isEditing] = useACHIsEditing();
  const [routingNumber, setRoutingNumber] = useRoutingNumber();

  const handleChange = (e) => {
    let value = e.target.value;
    let hasNonNumbers = /[^0-9]/.test(value);

    if (hasNonNumbers) return;

    if (value.length > 9) return;

    setRoutingNumber(value);
  };

  return (
    <AccountNumberInfo $isEditing={isEditing}>
      <Stack>
        <Label>Routing Number</Label>

        {isEditing ? (
          <SmallNumberInput
            ref={inputRef}
            value={routingNumber}
            type="text"
            inputMode="numeric"
            name="routingnumber"
            autoComplete="routing-number"
            autoFocus={false}
            tabIndex={2}
            onChange={handleChange}
            data-cy="stax-bank-routing-number-input"
          />
        ) : (
          <SmallNumber>&bull; &bull; &bull; &bull;</SmallNumber>
        )}
      </Stack>
    </AccountNumberInfo>
  );
}

const AccountNumberInfo = styled(Info)`
  width: 75%;
  border: 2px solid transparent;
  box-shadow: ${({ $isEditing }) =>
    `0 0 0 1px rgba(255, 255, 255, ${$isEditing ? 0.175 : 0}) inset`};
  background: rgba(255, 255, 255, 0);

  &:hover {
    border: ${(p) =>
      p.$isEditing
        ? "2px solid rgba(255, 255, 255, 0.6)"
        : "2px solid transparent"};
    background: ${(p) =>
      p.$isEditing ? "rgba(255, 255, 255, 0.1)" : "transparent"};
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0) inset;
    cursor: ${(p) => (p.$isEditing ? "pointer" : "default")};
  }
  &:focus-within {
    border: 2px solid rgba(255, 255, 255, 1);
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0) inset;
  }
`;
